import { AssetsEffects } from "#components/content-library/assign-cart/content-builder-store/effects/assets.effects";

// so we can just have one import in districts.module
export const effects: any[] = [AssetsEffects];

export * from "./assets.effects";
